/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoWalletTransferSetStatus } from '../../models/dto-wallet-transfer-set-status';
import { WalletTransferItem } from '../../models/wallet-transfer-item';

export interface BookingControllerWalletTransferSetStatus$Params {
  id: number;
      body: DtoWalletTransferSetStatus
}

export function bookingControllerWalletTransferSetStatus(http: HttpClient, rootUrl: string, params: BookingControllerWalletTransferSetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletTransferItem;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerWalletTransferSetStatus.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WalletTransferItem;
      }>;
    })
  );
}

bookingControllerWalletTransferSetStatus.PATH = '/booking/wallet/transfer/{id}/status';
